import classnames from "classnames";
import { nanoid } from "nanoid";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import classes from "../../../styles/Home.module.scss";

function CaseStudies({ caseStudy, className }) {
  return (
    <div className={className}>
      <div className={classnames(classes.heading, "heading")}>Case Studies</div>
      <div className={classnames("subheading")}>
        One of the best ways to understand the efficiency and effectiveness of
        Paytm’s services is by going through its case studies. These case
        studies showcase how Paytm has helped individuals and businesses in
        achieving their goals through its innovative solutions. These studies
        highlight the benefits and features of Paytm’s services, which makes it
        a preferred choice for many users in India.
      </div>
      <div className={classnames(classes.flex_box, "bannerSty")}>
        {caseStudy.map((element, index) => {
          return (
            <Banner
              type={BannerType.CASE_STUDY}
              {...element}
              key={nanoid()}
              className={`${classes.alignCenter} inner_sty`}
              backgroundColor={index % 2 == 0 ? "#B2EAFF" : "#B2D0FF"}
            />
          );
        })}
      </div>
    </div>
  );
}
export default CaseStudies;
